import { Typography, TypographyProps } from '@mui/material';
import { LoremIpsum } from 'lorem-ipsum';

const lorem = new LoremIpsum({});

export interface FakeWordsProps extends TypographyProps {
  words: number;
}

export function FakeWords({ words, ...props }: FakeWordsProps) {
  return <Typography {...props}>{lorem.generateWords(words)}</Typography>;
}
